/**
 * Desglose de lo que se descuenta en el detalle de cobranza (DSG-01..05; Mario, 1-nov). Solo presenta lo que ya manda el núcleo:
 * `totales.cargos` [{ concepto, monto }] por concepto, y la comisión y lo cobrado. El núcleo no dice si un cargo es fijo o
 * porcentual: la nota dice cuánto pesa sobre lo cobrado. Sin dependencias ni tipos complejos (la prueba lo carga sin TypeScript).
 */
const r2 = (n: any) => Math.round((Number(n) || 0) * 100) / 100;

/** DSG-01: «2 %», «1,5 %» o '' (sin base, sin monto o menos de 0,1 %). */
export const tasa = (monto: any, base: any): string => {
  const m = Number(monto) || 0, b = Number(base) || 0;
  if (!(b > 0) || !(m > 0)) return '';
  // un decimal: cada monto viene redondeado al centavo (7,52 de 377,06 es 1,994 %, se lee «2 %»)
  const p = Math.round((m / b) * 1000) / 10;
  return p >= 0.1 ? `${p.toLocaleString('es', { maximumFractionDigits: 1 })} %` : '';
};

const conNota = (fila: any, monto: any, base: any) => { const t = tasa(monto, base); return t ? { ...fila, nota: `${t} de lo cobrado` } : fila; };

/**
 * DSG-02..04: la cuenta del núcleo con la tasa de la comisión y la línea de cargos abierta en un renglón por concepto. Si el núcleo
 * no manda el desglose o no suma lo mismo que su línea, la línea queda como venía.
 */
export const cuentaConDesglose = (cuenta: any, totales: any): any[] => {
  if (!Array.isArray(cuenta)) return [];
  if (!totales) return cuenta;
  const cobrado = Number(totales.cobrado) || 0;
  const cargos = (Array.isArray(totales.cargos) ? totales.cargos : []).filter((c: any) => r2(c && c.monto) !== 0);
  const out: any[] = [];
  for (const fila of cuenta) {
    const concepto = String((fila && fila.concepto) || '');
    if (concepto === '− Comisión de cobranza') { out.push(conNota(fila, -fila.usd, cobrado)); continue; }
    const suma = r2(cargos.reduce((t: number, c: any) => t + (Number(c.monto) || 0), 0));
    if (concepto.startsWith('− Cargo') && cargos.length && Math.abs(suma - r2(-fila.usd)) <= 0.01) {
      for (const c of cargos) out.push(conNota({ concepto: `− ${c.concepto}`, usd: -r2(c.monto) }, c.monto, cobrado));
      continue;
    }
    out.push(fila);
  }
  return out;
};

/** DSG-05: los conceptos de la columna «Cargos» de las ventas: «uso tecnológico, cargo por uso» o ''. */
export const conceptosDeCargos = (totales: any): string => {
  const lista = (totales && Array.isArray(totales.cargos) ? totales.cargos : []).map((c: any) => String((c && c.concepto) || '').toLowerCase()).filter(Boolean);
  return [...new Set(lista)].join(', ');
};
